import { HEADER_MEDIA_SOURCES } from "../../../../utils/config/mediaSources/header";
import { renderSources } from "../../../../utils/index.ts";

export default function Logo() {    

    return (
        <picture className="mx-0 w-[30%] sm:p-5">
            {renderSources(HEADER_MEDIA_SOURCES.header.logo.srcSet)}

            <img
                tabIndex={-1}
                src={HEADER_MEDIA_SOURCES.header.logo.img.defaultSrc}
                alt={HEADER_MEDIA_SOURCES.header.logo.img.alt || "GuacnTacos Logo"}
                loading="eager"
                fetchPriority="high"
                width={HEADER_MEDIA_SOURCES.header.logo.img.width}
                height={HEADER_MEDIA_SOURCES.header.logo.img.height}
                className={`
                    block
                    w-35 lg:w-[17vw] xl:w-[16vw] xl:mt-5 h-auto aspect-[1079/639]
                    focus:rotate-[13deg] active:scale-90 hover:rotate-[13deg] hover:scale-110 transition-transform ease-in duration-700
                `}
                decoding="sync"
            />
        </picture>
    )
}